import React from "react";
import { WidgetProps } from "@rjsf/core";
import { TEvaluationCehckValue } from "./EvalutaionCheckWidget";
import { IconProps, Icon } from "semantic-ui-react";
import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

const getTextProps = (t: TFunction) => ({
    ok: t("Kunnossa"),
    notOk: t("Korjattavaa"),
    uknown: t("Ei tietoa"),
});

export const EvalutaionCheckDisplay: React.FC<WidgetProps> = (props) => {
    const texts = getTextProps(useTranslation().t)

    const { schema } = props
    const valueObj: TEvaluationCehckValue = typeof props.value === "object" && props.value?.notes ? props.value : { notes: [] }
    const enums: any[] = schema.enum ?? [0, 1, 2];

    if (enums.length > 3) { console.warn("EvalutaionCheckDisplay recieved more than 3 enums"); };

    const renderItem = (text: string, iconProps: IconProps) => (
        <div>
            <Icon {...iconProps} />
            {text}
        </div>
    );

    return (
        <div>
            {valueObj.status === enums[1] && renderItem(texts.ok, { name: "check", color: "green" })}
            {valueObj.status === enums[0] && renderItem(texts.notOk, { name: "times", color: "red" })}
            {valueObj.status === enums[2] && renderItem(texts.uknown, { name: "question" })}
        </div>

    )
};
